import { render, staticRenderFns } from "./InteractiveRoofTest.vue?vue&type=template&id=1b6b8f76&scoped=true&"
import script from "./InteractiveRoofTest.vue?vue&type=script&lang=js&"
export * from "./InteractiveRoofTest.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveRoofTest.vue?vue&type=style&index=0&id=1b6b8f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b8f76",
  null
  
)

export default component.exports